import React from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import AuthProvider from "./context/authContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Routers from "./routers/Routers";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Chatbot from "./components/Chatbot/Chatbot";
import { CartProvider } from "./context/cartContext";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet-async";
import { siteConfig } from "./utils/site";

// Import World-Class Design System
import "./styles/world-class-luxury.css";
import "./styles/trust-ui.css";

const googleClientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID";

const AppContent = () => {
  const location = useLocation();
  const isAdminExperience =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/delivery/admin");

  return (
    <>
      {!isAdminExperience && <Header />}
      <Routers />
      {!isAdminExperience && <Footer />}
      {!isAdminExperience && <Chatbot />}
    </>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <html lang="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="format-detection" content="telephone=no" />
        <meta name="theme-color" content="#0B1F1A" />
        <meta name="msapplication-TileColor" content="#0B1F1A" />
        <meta name="apple-mobile-web-app-title" content={siteConfig.name} />
        <meta name="application-name" content={siteConfig.name} />
        <meta name="description" content={siteConfig.description} />
        <meta name="keywords" content={siteConfig.defaultKeywords} />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
        <link rel="icon" type="image/png" href="/favicon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/site.webmanifest" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: siteConfig.name,
            alternateName: "Roha Ethiopian Gemstone Jewellery",
            url: siteConfig.url,
            description: siteConfig.description,
            inLanguage: "en-US",
            publisher: {
              "@type": "JewelryStore",
              name: siteConfig.name,
              url: siteConfig.url,
              logo: siteConfig.logo,
              telephone: siteConfig.phones,
              email: siteConfig.email,
              address: {
                "@type": "PostalAddress",
                streetAddress: "Bole",
                addressLocality: "Addis Ababa",
                addressCountry: "ET",
              },
            },
            creator: {
              "@type": "JewelryStore",
              name: siteConfig.name,
              url: siteConfig.url,
              logo: `${siteConfig.url}/logo192.png`,
              address: {
                "@type": "PostalAddress",
                streetAddress: "Bole",
                addressLocality: "Addis Ababa",
                addressCountry: "ET",
              },
              telephone: siteConfig.phones,
              email: siteConfig.email,
            },
            potentialAction: {
              "@type": "SearchAction",
              target: `${siteConfig.url}/products?search={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "JewelryStore",
            name: siteConfig.name,
            url: siteConfig.url,
            image: siteConfig.socialImage,
            logo: siteConfig.logo,
            description: siteConfig.description,
            telephone: siteConfig.phones,
            email: siteConfig.email,
            address: {
              "@type": "PostalAddress",
              streetAddress: "Bole",
              addressLocality: "Addis Ababa",
              addressCountry: "ET",
            },
            openingHours: "Mo-Sa 09:00-19:00",
            priceRange: "$$$",
            currenciesAccepted: "ETB, USD, EUR",
            areaServed: "Worldwide",
          })}
        </script>
      </Helmet>

      <GoogleOAuthProvider clientId={googleClientId}>
        <AuthProvider>
          <CartProvider>
            <Router>
              <AppContent />
            </Router>
          </CartProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
};

export default App;
